import React from 'react'

const SellerAnalytics = () => {
  return (
    <div>SellerAnalytics</div>
  )
}

export default SellerAnalytics